import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"

const Help = props => {
  //meta title
  document.title = `${props.t("Help")} | ${process.env.REACT_APP_CMS_TITLE}`

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Help")}
            breadcrumbItem={props.t("Help")}
          />
          {/* Add your help content here */}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(Help)
